<template>
    <row>
        <div class="col-xl-4 col-md-6">
            <stats-card>
                <div slot="header" class="icon-warning">
                    <i class="nc-icon nc-zoom-split text-warning"></i>
                </div>
                <div slot="content">
                    <p class="card-category">Casos em Suspeita</p>
                    <h4 style="font-size: 50px;margin-top: 10px;" class="card-title">{{suspectedCases}}</h4>
                </div>
                <div slot="footer">
                    <i class="fa fa-clock-o"></i>Ultima atualização: {{lastUpdatedFormated}}
                </div>
            </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
            <stats-card>
                <div slot="header" class="icon-danger">
                    <i class="nc-icon nc-simple-remove text-success"></i>
                </div>
                <div slot="content">
                    <p class="card-category">Casos Descartados</p>
                    <h4 style="font-size: 50px;margin-top: 10px;"  class="card-title">{{discardedCases}}</h4>
                </div>
                <div slot="footer">
                    <i class="fa fa-clock-o"></i>Ultima atualização: {{lastUpdatedFormated}}
                </div>
            </stats-card>
        </div>

        <div class="col-xl-4 col-md-12">
            <stats-card>
                <div slot="header" class="icon-success">
                    <i class="nc-icon nc-check-2 text-danger "></i>
                </div>
                <div slot="content">
                    <p class="card-category">Casos Confirmados</p>
                    <h4 style="font-size: 50px;margin-top: 10px;"  class="card-title">{{confirmedCases}}</h4>
                </div>
                <div slot="footer">
                    <i class="fa fa-clock-o"></i>Ultima atualização: {{lastUpdatedFormated}}
                </div>
            </stats-card>
        </div>
    </row>
</template>

<script>
    import Row from "@/components/Row";
    import StatsCard from "@/components/StatsCard";
    import moment from 'moment';
    export default {
        name: "Counters",
        components: {StatsCard, Row},
        props: ['suspectedCases', 'confirmedCases', 'discardedCases', 'lastUpdated'],
        computed:{
            lastUpdatedFormated (){
                return moment(this.lastUpdated, 'YYYY-MM-DD').format('DD/MM/YYYY [às] HH:mm:ss')
            }
        }
    }
</script>

<style scoped>

</style>
